// Masks contact/identity details in user-typed free text before it leaves for
// analytics. Pattern-based, so it can't catch names; order matters (cards before
// phones, since a card number contains phone-shaped digit runs).

// A digit run is only masked as a card if it passes Luhn. Without that check a
// run spanning two hyphenated phone numbers is masked as one card, which both
// mislabels them and leaves the trailing digits exposed.
function passesLuhn(digits) {
    let sum = 0;
    let double = false;
    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = Number(digits[i]);
        if (double) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
        double = !double;
    }
    return sum % 10 === 0;
}

function isCardNumber(match) {
    const digits = match.replace(/\D/g, '');
    return digits.length >= 13 && digits.length <= 19 && passesLuhn(digits);
}

// [pattern, default mask, guard?] — a guard that rejects the match leaves the
// text as typed, so it can still be picked up by a later pattern.
const patterns = [
    [/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]'],
    [/(?<!\d)\d{3}[-.\s]\d{2}[-.\s]\d{4}(?!\d)/g, '[ssn]'],
    [/(?<!\d)\d{3,}(?:[ -]\d{3,})*(?!\d)/g, '[card]', isCardNumber],
    [/(?<![\d+])(?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}(?!\d)/g, '[phone]'],
];

// `mask` replaces the default labels for every pattern when it is a string,
// including an empty one, which drops the matched text entirely. Omit it to
// keep the labels, which record in analytics that something was stripped.
export function scrubPii(text, mask) {
    if (typeof text !== 'string' || !text) {
        return text;
    }
    const replacement = typeof mask === 'string' ? mask : null;
    return patterns.reduce((result, [pattern, label, guard]) => result.replace(pattern, (match) => (guard && !guard(match) ? match : replacement ?? label)), text);
}
